module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAASCAYAAABB7B6eAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwgAADsIBFShKgAAAABp0RVh0U29mdHdhcmUAUGFpbnQuTkVUIHYzLjUuMTAw9HKhAAAARklEQVQ4T7XRIRIAQAjDQP7/6d6hMJFpZ9ZEwvylDKMJowmjJ+nCaMJo2t29OjCaMJoweugxJowmjKbd3asDowmjCaNk8gB3nc1PuKV26gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/icon-menu-minimized.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/icon-menu-minimized.png
// module chunks = styles